import { NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SafeHtmlPipe } from '@app/finxone-web-frontend/app/lib/pipes/SafeHtml.pipe';
import { baseCssConfigStyle } from '@finxone-platform/shared/sys-config-types';

@Component({
  selector: 'finxone-web-frontend-text',
  imports: [NgStyle, NgClass, SafeHtmlPipe],
  templateUrl: './text.component.html',
  styleUrls: ['./text.component.scss'],
})
export class TextComponent {
  @Input() public contentStyle: baseCssConfigStyle;
  @Input() public isUsingHtmlStructure: boolean;
  @Input() public colorTextAlignStyle: baseCssConfigStyle;
  @Input() public renderedContent = '';
  @Input() public selectedTextStyleClass = '';
}
